import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { auth } from '@/firebaseConfig'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:lang(en|zh)?',
    props: true,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('../views/Admin.vue'),
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            name: 'HuntList',
            component: () => import('../views/admin/HuntList.vue'),
          },
          {
            path: 'edit/:id',
            name: 'HuntEdit',
            component: () => import('../views/admin/HuntEdit.vue'),
          },
          {
            path: 'media-upload',
            name: 'MediaUpload',
            component: () => import('../views/Media.vue'),
          }
        ]
      },
      {
        path: 'intro',
        name: 'Intro',
        component: () => import('../views/Intro.vue'),
      },
      {
        path: 'hunt',
        name: 'Hunt',
        component: () => import('../views/Hunt.vue'),
      },

      // ✅ ADD THIS
      {
        path: 'end',
        name: 'End',
        component: () => import('../views/End.vue'),
      },

      {
        path: 'memories',
        name: 'Memories',
        component: () => import('../views/Memories.vue'),
      },
      {
        path: 'memories/kuokuan',
        redirect: (to) => ({
          name: 'ARMemory',
          params: { ...to.params, memoryId: 'kuokuang' },
        }),
      },
      {
        path: 'memories/:memoryId',
        name: 'ARMemory',
        component: () => import('../views/memories/ARMemory.vue'),
        props: true,
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const requiresAuth = to.matched.some(
    (record) => record.meta.requiresAuth
  )

  if (requiresAuth && !auth.currentUser) {
    return '/'
  }
})

export default router
